module.exports = __webpack_public_path__ + "img/hover_icon_alternative_location_catalog.ec7e866d.svg";